module.exports = __webpack_public_path__ + "static/media/eziotlogo.22914c06.png";